import {useState, useEffect} from 'react';
import validate from 'validate.js';

const defaultForm = {
    isValid: false,
    values: {},
    touched: {},
    errors: {}
};

const defaultFormConstraints = {};

export default function useForm(initialForm, initialFormConstraints) {

    const [form, setForm] = useState(initialForm ? initialForm : defaultForm);
    const [constraints, setConstraints] = useState(initialFormConstraints ? initialFormConstraints : defaultFormConstraints);

    useEffect(() => {
        let errors = validate(form.values, constraints);
        setForm((prevForm) => ({
            ...prevForm,
            isValid: !errors,
            errors: errors || {}
        }));
    }, [form.values]);

    const handleFormChange = event => {
        try {
            event.persist();
        } catch (err) {
            console.log(err);
        }

        if (event instanceof Date) {
            setPropValue('fechaCompra', event);
        } else {
            let prop = event.target.name;
            let value = event.target.type === 'checkbox'
                ? event.target.checked
                : event.target.value;
            setPropValue(prop, value.toUpperCase());
        }
    };

    const setPropValue = (prop, value) => {
        setForm((prevForm) => ({
            ...prevForm,
            values: {
                ...prevForm.values,
                [prop]: value
            },
            touched: {
                ...prevForm.touched,
                [prop]: true
            }
        }));
    };

    const hasError = (field) => (!!(form.touched[field] && form.errors[field]));

    const isFormValid = () => {
        return form.isValid;
    };

    const resetForm = () => {
        setForm(defaultForm);
    };

    const getValue = (prop) => {
        if (form && form.values && form.values[prop]) {
            return form.values[prop];
        }
        return null;
    };

    const getMessageError = (prop) => {
        if (hasError(prop)) {
            let message = form.errors[prop];
            return message[0];
        }
        return null;
    };

    return {
        handleFormChange,
        hasError,
        isFormValid,
        setPropValue,
        form,
        getValue,
        getMessageError,
        setForm,
        constraints,
        setConstraints
    };
}